import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import GridContainer from "@frameworks/web/components/generic/CommonUI/GridContainer";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import RadioButton from "@frameworks/web/components/generic/radioButton";
import { ILoginAccountTypes } from "@domains/features/LoginFlow/entities/CommonLoginData";
import DeviceContext from "@frameworks/web/components/generic/customHooks/indentifyDevice";
const accTypes = [
    { value: ILoginAccountTypes.EQ, display: "Equity" },
    { value: ILoginAccountTypes.CO, display: "Commodity" },
];
export const ChooseAccountForLogin = (props) => {
    const [accType, setAccType] = useState();
    const device = DeviceContext();
    const [activeClassName, setActiveClassName] = useState({ isEquity: false, isCommodity: false });
    React.useEffect(() => {
        if (accType) {
            if (accType === accTypes[0].value) {
                setActiveClassName({ isEquity: true, isCommodity: false });
            }
            else if (accType === accTypes[1].value) {
                setActiveClassName({ isEquity: false, isCommodity: true });
            }
        }
    }, [accType]);
    const componentChild = () => {
        return (React.createElement(React.Fragment, null,
            React.createElement(Row, { className: device && device.isDesktop
                    ? "DMSansBold_20_700 txt-midnight-blue m-0 pb-30"
                    : "DMSansBold_20_700 txt-midnight-blue m-0 pb-30 pt-3" }, props.pageTitle && props.pageTitle),
            React.createElement("form", { id: "clientLogin_form radioBoxsectionfundtype" },
                React.createElement("label", { className: props.description
                        ? "DMSanN_14_400 txt_primaryGrey mt-30 mb-md-3 mb-4"
                        : "DMSanN_14_400 txt_primaryGrey" }, props.description && props.description),
                React.createElement(Row, { className: "clientLogin_inputfield" },
                    React.createElement(Col, { lg: 6, md: 6, sm: 6, xs: 6 },
                        React.createElement(RadioButton, { list: accTypes[0], name: "accType", onChange: () => {
                                setAccType(accTypes[0].value);
                                props.setAccountType(ILoginAccountTypes.EQ);
                            }, selected: accType, disabled: props.equityDisabled, avoidchekmark: true, className: activeClassName.isEquity
                                ? "Box-radiobutton active"
                                : "Box-radiobutton" })),
                    React.createElement(Col, { lg: 6, md: 6, sm: 6, xs: 6 },
                        React.createElement(RadioButton, { list: accTypes[1], name: "accType", onChange: () => {
                                setAccType(accTypes[1].value);
                                props.setAccountType(ILoginAccountTypes.CO);
                            }, selected: accType, disabled: props.commodityDisabled, avoidchekmark: true, className: activeClassName.isCommodity
                                ? "Box-radiobutton active"
                                : "Box-radiobutton" }))),
                props.showNextButton && (React.createElement(Row, { className: "m-0 pb-125" },
                    React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Next", onClick: () => {
                            props.submitFunction(accType);
                        }, type: "button", disabled: props === null || props === void 0 ? void 0 : props.disableSubmit })))),
            " "));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "chooseAccount" }, props.noGridContainer ? (componentChild()) : (React.createElement(GridContainer, null, componentChild())))));
};
